/**
 * Do not edit directly
 * Generated on Tue, 04 Jan 2022 20:13:09 GMT
 */
const BorderRadius = 2;
const BorderWidth = 1;
const BorderColor = "#dfe6e9";
const ColorWhite = "#ffffff";
const ColorCool = "#f5f7f8";
const ColorStainless = "#dfe6e9";
const ColorStainlessOpac20 = "#dfe6e9";
const ColorGray = "#b2bec3";
const ColorAsphalt = "#636e72";
const ColorInk = "#2d3436";
const ColorChar = "#1e2224";
const ColorBlack = "#000000";
const ColorBrandDowjones = "#02a3d5";
const ColorMain = "#5755d9";
const ColorRose10 = "#ffdde9";
const ColorRose20 = "#ffbbd3";
const ColorRose30 = "#ff99be";
const ColorRose40 = "#ff77a8";
const ColorRose50 = "#ff5592";
const ColorRose60 = "#cc4475";
const ColorRose70 = "#993358";
const ColorRose80 = "#66223a";
const ColorRose90 = "#33111d";
const ColorRose05 = "#ffeef4";
const ColorLava10 = "#fad9d4";
const ColorLava20 = "#f4b3a8";
const ColorLava30 = "#ef8e7d";
const ColorLava40 = "#e96851";
const ColorLava50 = "#e44226";
const ColorLava60 = "#b6351e";
const ColorLava70 = "#892817";
const ColorLava80 = "#5b1a0f";
const ColorLava90 = "#2e0d08";
const ColorLava05 = "#fcece9";
const ColorTangerine10 = "#fde9da";
const ColorTangerine20 = "#fbd3b6";
const ColorTangerine30 = "#fabc91";
const ColorTangerine40 = "#f8a66c";
const ColorTangerine50 = "#f69047";
const ColorTangerine60 = "#c57339";
const ColorTangerine70 = "#764522";
const ColorTangerine80 = "#623a1d";
const ColorTangerine90 = "#311d0e";
const ColorTangerine05 = "#fef3ec";
const ColorSunshine10 = "#fef3d9";
const ColorSunshine20 = "#fce7b4";
const ColorSunshine30 = "#fbdc8e";
const ColorSunshine40 = "#f9d069";
const ColorSunshine50 = "#f8c443";
const ColorSunshine60 = "#c69d36";
const ColorSunshine70 = "#957628";
const ColorSunshine80 = "#634e1b";
const ColorSunshine90 = "#32270d";
const ColorSunshine05 = "#fef9ec";
const ColorEmerald10 = "#dcf5da";
const ColorEmerald20 = "#b9ecb4";
const ColorEmerald30 = "#97e28f";
const ColorEmerald40 = "#74d969";
const ColorEmerald50 = "#51cf44";
const ColorEmerald60 = "#41a636";
const ColorEmerald70 = "#317c29";
const ColorEmerald80 = "#20531b";
const ColorEmerald90 = "#10290e";
const ColorEmerald05 = "#edfaec";
const ColorIce10 = "#d9f6ff";
const ColorIce20 = "#b3ecff";
const ColorIce30 = "#8de3ff";
const ColorIce40 = "#66daff";
const ColorIce50 = "#40d0ff";
const ColorIce60 = "#33a7cc";
const ColorIce70 = "#277d99";
const ColorIce80 = "#1a5366";
const ColorIce90 = "#0d2a33";
const ColorIce05 = "#ebfaff";
const ColorBlurple10 = "#ddddf7";
const ColorBlurple20 = "#bcbbf0";
const ColorBlurple30 = "#9a99e8";
const ColorBlurple40 = "#7977e1";
const ColorBlurple50 = "#5755d9";
const ColorBlurple60 = "#4644ae";
const ColorBlurple70 = "#343382";
const ColorBlurple80 = "#232257";
const ColorBlurple90 = "#11112b";
const ColorBlurple05 = "#eeeefb";
const ColorBlurpleOpac50 = "#5755d9";
const FontStack = "'Inter UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
const FontSizeSm = "0.8125rem";
const FontSizeMd = "1rem";
const FontSizeLg = "1.125rem";
const FontSizeXl = "1.3125rem";
const FontSizeXxl = "1.75rem";
const FontSizeLgBp2 = "1.3125rem";
const FontSizeXlBp2 = "1.75rem";
const FontSizeXxlBp2 = "2.375rem";
const FontLineHeightSm = "1rem";
const FontLineHeightMd = "1.5rem";
const FontLineHeightLg = "1.625rem";
const FontLineHeightXl = "1.875rem";
const FontLineHeightXxl = "2.5625rem";
const FontLineHeightLgBp2 = "1.875rem";
const FontLineHeightXlBp2 = "2.5625rem";
const FontLineHeightXxlBp2 = "3.4375rem";
const FontWeightReg = 400;
const FontWeightMed = 500;
const FontWeightBold = 700;
const FontWeightBlack = 900;
const CodeFontStack = "Courier, monospace";
const GridBreakpointXsMax = "47.999rem";
const GridBreakpointSmMin = "48rem";
const GridBreakpointSmMax = "63.999rem";
const GridBreakpointMdMin = "64rem";
const GridBreakpointMdMax = "74.999rem";
const GridBreakpointLgMin = "75rem";
const GridGutterWidth = "1rem";
const GridGutterHalf = "0.5rem";
const GridGutterCompensation = "-0.5rem";
const GridContainerSm = "49rem";
const GridContainerMd = "65rem";
const GridContainerLg = "76rem";
const GridMarginOuter = "0rem";
const GridPageFullwidth = "75rem";
const BtnHeight = 40;
const BtnPrimaryColor = "#ffffff";
const BtnPrimaryBg = "#5755d9";
const BtnPrimaryBgHover = "#4644ae";
const BtnPrimaryBgActive = "#343382";
const BtnSecondaryColor = "#5755d9";
const BtnSecondaryColorHover = "#5755d9";
const BtnSecondaryBg = "#ffffff";
const BtnSecondaryBgHover = "#eeeefb";
const BtnSecondaryBgActive = "#ddddf7";
const BtnGrayColor = "#2d3436";
const BtnGrayColorHover = "#2d3436";
const BtnGrayBg = "transparent";
const BtnGrayBgHover = "#f5f7f8";
const BtnGrayBgActive = "#dfe6e9";
const BtnAsphaltColor = "#636e72";
const BtnAsphaltBg = "transparent";
const BtnAsphaltBgHover = "#f5f7f8";
const BtnAsphaltBgActive = "#f5f7f8";
const BtnLavaColor = "#e44226";
const BtnLavaBg = "transparent";
const BtnLavaBgHover = "#fcece9";
const BtnLavaBgActive = "#fad9d4";
const BtnEmeraldColor = "#51cf44";
const BtnEmeraldBg = "transparent";
const BtnEmeraldBgHover = "#edfaec";
const BtnEmeraldBgActive = "#dcf5da";
const BtnWhiteColor = "#ffffff";
const BtnWhiteBg = "transparent";
const BtnWhiteBgHover = "rgba(255, 255, 255, 0.2)";
const BtnWhiteBgActive = "rgba(255, 255, 255, 0.3)";
const SidebarWidthOpen = 260;
const SidebarWidthCollapsed = 32;
const HeaderbarHeightBp1 = 60;
const HeaderbarHeightBp2 = 48;
const SpacerXs = 4;
const SpacerSm = 8;
const SpacerSmd = 12;
const SpacerMd = 16;
const SpacerMlg = 24;
const SpacerLg = 32;
const SpacerXl = 48;
const ZindexTop = 100000000000000000;
const ZindexMajor = 100;
const ZindexMad = 30;
const ZindexMid = 2;
const ZindexMinor = 1;
const PageBg = "#f5f7f8";
const ContentBg = "#ffffff";
const ContentBgHover = "#eeeefb";
const ContentBgActive = "#f5f7f8";
const TextColor = "#2d3436";
const TextColorSupport = "#636e72";
const TextColorAccent = "#5755d9";
const TextColorInk = "#2d3436";
const TextColorBlurple = "#5755d9";
const TextColorAsphalt = "#636e72";
const TextColorLava = "#e44226";
const TextColorEmerald = "#51cf44";
const TextColorWhite = "#ffffff";
const NavColor = "#5755d9";
const NavColorHover = "#5755d9";
const NavBg = "#ffffff";
const NavBgHover = "#eeeefb";
const NavBgActive = "#eeeefb";
const TokenBlurpleColor = "#343382";
const TokenBlurpleBg = "#ddddf7";
const TokenGrayColor = "#2d3436";
const TokenGrayBg = "#dfe6e9";
const TokenRoseColor = "#993358";
const TokenRoseBg = "#ffdde9";
const TokenLavaColor = "#892817";
const TokenLavaBg = "#fad9d4";
const TokenTangerineColor = "#764522";
const TokenTangerineBg = "#fde9da";
const TokenSunshineColor = "#957628";
const TokenSunshineBg = "#fef3d9";
const TokenEmeraldColor = "#317c29";
const TokenEmeraldBg = "#dcf5da";
const TokenIceColor = "#277d99";
const TokenIceBg = "#d9f6ff";
const InputBg = "#ffffff";
const InputBgDisabled = "#f5f7f8";
const InputBgError = "#fcece9";
const InputHandleColor = "#ffffff";
const InputTrackColor = "#b2bec3";
const InputTrackColorError = "#ef8e7d";
const InputIconColor = "#b2bec3";
const InputIconColorActive = "#5755d9";
const InputIconColorError = "#e44226";
const InputColorError = "#e44226";
const InputColorActive = "#5755d9";
const InputOutlineColorActive = "#5755d9";

var _variables_es6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	BorderRadius: BorderRadius,
	BorderWidth: BorderWidth,
	BorderColor: BorderColor,
	ColorWhite: ColorWhite,
	ColorCool: ColorCool,
	ColorStainless: ColorStainless,
	ColorStainlessOpac20: ColorStainlessOpac20,
	ColorGray: ColorGray,
	ColorAsphalt: ColorAsphalt,
	ColorInk: ColorInk,
	ColorChar: ColorChar,
	ColorBlack: ColorBlack,
	ColorBrandDowjones: ColorBrandDowjones,
	ColorMain: ColorMain,
	ColorRose10: ColorRose10,
	ColorRose20: ColorRose20,
	ColorRose30: ColorRose30,
	ColorRose40: ColorRose40,
	ColorRose50: ColorRose50,
	ColorRose60: ColorRose60,
	ColorRose70: ColorRose70,
	ColorRose80: ColorRose80,
	ColorRose90: ColorRose90,
	ColorRose05: ColorRose05,
	ColorLava10: ColorLava10,
	ColorLava20: ColorLava20,
	ColorLava30: ColorLava30,
	ColorLava40: ColorLava40,
	ColorLava50: ColorLava50,
	ColorLava60: ColorLava60,
	ColorLava70: ColorLava70,
	ColorLava80: ColorLava80,
	ColorLava90: ColorLava90,
	ColorLava05: ColorLava05,
	ColorTangerine10: ColorTangerine10,
	ColorTangerine20: ColorTangerine20,
	ColorTangerine30: ColorTangerine30,
	ColorTangerine40: ColorTangerine40,
	ColorTangerine50: ColorTangerine50,
	ColorTangerine60: ColorTangerine60,
	ColorTangerine70: ColorTangerine70,
	ColorTangerine80: ColorTangerine80,
	ColorTangerine90: ColorTangerine90,
	ColorTangerine05: ColorTangerine05,
	ColorSunshine10: ColorSunshine10,
	ColorSunshine20: ColorSunshine20,
	ColorSunshine30: ColorSunshine30,
	ColorSunshine40: ColorSunshine40,
	ColorSunshine50: ColorSunshine50,
	ColorSunshine60: ColorSunshine60,
	ColorSunshine70: ColorSunshine70,
	ColorSunshine80: ColorSunshine80,
	ColorSunshine90: ColorSunshine90,
	ColorSunshine05: ColorSunshine05,
	ColorEmerald10: ColorEmerald10,
	ColorEmerald20: ColorEmerald20,
	ColorEmerald30: ColorEmerald30,
	ColorEmerald40: ColorEmerald40,
	ColorEmerald50: ColorEmerald50,
	ColorEmerald60: ColorEmerald60,
	ColorEmerald70: ColorEmerald70,
	ColorEmerald80: ColorEmerald80,
	ColorEmerald90: ColorEmerald90,
	ColorEmerald05: ColorEmerald05,
	ColorIce10: ColorIce10,
	ColorIce20: ColorIce20,
	ColorIce30: ColorIce30,
	ColorIce40: ColorIce40,
	ColorIce50: ColorIce50,
	ColorIce60: ColorIce60,
	ColorIce70: ColorIce70,
	ColorIce80: ColorIce80,
	ColorIce90: ColorIce90,
	ColorIce05: ColorIce05,
	ColorBlurple10: ColorBlurple10,
	ColorBlurple20: ColorBlurple20,
	ColorBlurple30: ColorBlurple30,
	ColorBlurple40: ColorBlurple40,
	ColorBlurple50: ColorBlurple50,
	ColorBlurple60: ColorBlurple60,
	ColorBlurple70: ColorBlurple70,
	ColorBlurple80: ColorBlurple80,
	ColorBlurple90: ColorBlurple90,
	ColorBlurple05: ColorBlurple05,
	ColorBlurpleOpac50: ColorBlurpleOpac50,
	FontStack: FontStack,
	FontSizeSm: FontSizeSm,
	FontSizeMd: FontSizeMd,
	FontSizeLg: FontSizeLg,
	FontSizeXl: FontSizeXl,
	FontSizeXxl: FontSizeXxl,
	FontSizeLgBp2: FontSizeLgBp2,
	FontSizeXlBp2: FontSizeXlBp2,
	FontSizeXxlBp2: FontSizeXxlBp2,
	FontLineHeightSm: FontLineHeightSm,
	FontLineHeightMd: FontLineHeightMd,
	FontLineHeightLg: FontLineHeightLg,
	FontLineHeightXl: FontLineHeightXl,
	FontLineHeightXxl: FontLineHeightXxl,
	FontLineHeightLgBp2: FontLineHeightLgBp2,
	FontLineHeightXlBp2: FontLineHeightXlBp2,
	FontLineHeightXxlBp2: FontLineHeightXxlBp2,
	FontWeightReg: FontWeightReg,
	FontWeightMed: FontWeightMed,
	FontWeightBold: FontWeightBold,
	FontWeightBlack: FontWeightBlack,
	CodeFontStack: CodeFontStack,
	GridBreakpointXsMax: GridBreakpointXsMax,
	GridBreakpointSmMin: GridBreakpointSmMin,
	GridBreakpointSmMax: GridBreakpointSmMax,
	GridBreakpointMdMin: GridBreakpointMdMin,
	GridBreakpointMdMax: GridBreakpointMdMax,
	GridBreakpointLgMin: GridBreakpointLgMin,
	GridGutterWidth: GridGutterWidth,
	GridGutterHalf: GridGutterHalf,
	GridGutterCompensation: GridGutterCompensation,
	GridContainerSm: GridContainerSm,
	GridContainerMd: GridContainerMd,
	GridContainerLg: GridContainerLg,
	GridMarginOuter: GridMarginOuter,
	GridPageFullwidth: GridPageFullwidth,
	BtnHeight: BtnHeight,
	BtnPrimaryColor: BtnPrimaryColor,
	BtnPrimaryBg: BtnPrimaryBg,
	BtnPrimaryBgHover: BtnPrimaryBgHover,
	BtnPrimaryBgActive: BtnPrimaryBgActive,
	BtnSecondaryColor: BtnSecondaryColor,
	BtnSecondaryColorHover: BtnSecondaryColorHover,
	BtnSecondaryBg: BtnSecondaryBg,
	BtnSecondaryBgHover: BtnSecondaryBgHover,
	BtnSecondaryBgActive: BtnSecondaryBgActive,
	BtnGrayColor: BtnGrayColor,
	BtnGrayColorHover: BtnGrayColorHover,
	BtnGrayBg: BtnGrayBg,
	BtnGrayBgHover: BtnGrayBgHover,
	BtnGrayBgActive: BtnGrayBgActive,
	BtnAsphaltColor: BtnAsphaltColor,
	BtnAsphaltBg: BtnAsphaltBg,
	BtnAsphaltBgHover: BtnAsphaltBgHover,
	BtnAsphaltBgActive: BtnAsphaltBgActive,
	BtnLavaColor: BtnLavaColor,
	BtnLavaBg: BtnLavaBg,
	BtnLavaBgHover: BtnLavaBgHover,
	BtnLavaBgActive: BtnLavaBgActive,
	BtnEmeraldColor: BtnEmeraldColor,
	BtnEmeraldBg: BtnEmeraldBg,
	BtnEmeraldBgHover: BtnEmeraldBgHover,
	BtnEmeraldBgActive: BtnEmeraldBgActive,
	BtnWhiteColor: BtnWhiteColor,
	BtnWhiteBg: BtnWhiteBg,
	BtnWhiteBgHover: BtnWhiteBgHover,
	BtnWhiteBgActive: BtnWhiteBgActive,
	SidebarWidthOpen: SidebarWidthOpen,
	SidebarWidthCollapsed: SidebarWidthCollapsed,
	HeaderbarHeightBp1: HeaderbarHeightBp1,
	HeaderbarHeightBp2: HeaderbarHeightBp2,
	SpacerXs: SpacerXs,
	SpacerSm: SpacerSm,
	SpacerSmd: SpacerSmd,
	SpacerMd: SpacerMd,
	SpacerMlg: SpacerMlg,
	SpacerLg: SpacerLg,
	SpacerXl: SpacerXl,
	ZindexTop: ZindexTop,
	ZindexMajor: ZindexMajor,
	ZindexMad: ZindexMad,
	ZindexMid: ZindexMid,
	ZindexMinor: ZindexMinor,
	PageBg: PageBg,
	ContentBg: ContentBg,
	ContentBgHover: ContentBgHover,
	ContentBgActive: ContentBgActive,
	TextColor: TextColor,
	TextColorSupport: TextColorSupport,
	TextColorAccent: TextColorAccent,
	TextColorInk: TextColorInk,
	TextColorBlurple: TextColorBlurple,
	TextColorAsphalt: TextColorAsphalt,
	TextColorLava: TextColorLava,
	TextColorEmerald: TextColorEmerald,
	TextColorWhite: TextColorWhite,
	NavColor: NavColor,
	NavColorHover: NavColorHover,
	NavBg: NavBg,
	NavBgHover: NavBgHover,
	NavBgActive: NavBgActive,
	TokenBlurpleColor: TokenBlurpleColor,
	TokenBlurpleBg: TokenBlurpleBg,
	TokenGrayColor: TokenGrayColor,
	TokenGrayBg: TokenGrayBg,
	TokenRoseColor: TokenRoseColor,
	TokenRoseBg: TokenRoseBg,
	TokenLavaColor: TokenLavaColor,
	TokenLavaBg: TokenLavaBg,
	TokenTangerineColor: TokenTangerineColor,
	TokenTangerineBg: TokenTangerineBg,
	TokenSunshineColor: TokenSunshineColor,
	TokenSunshineBg: TokenSunshineBg,
	TokenEmeraldColor: TokenEmeraldColor,
	TokenEmeraldBg: TokenEmeraldBg,
	TokenIceColor: TokenIceColor,
	TokenIceBg: TokenIceBg,
	InputBg: InputBg,
	InputBgDisabled: InputBgDisabled,
	InputBgError: InputBgError,
	InputHandleColor: InputHandleColor,
	InputTrackColor: InputTrackColor,
	InputTrackColorError: InputTrackColorError,
	InputIconColor: InputIconColor,
	InputIconColorActive: InputIconColorActive,
	InputIconColorError: InputIconColorError,
	InputColorError: InputColorError,
	InputColorActive: InputColorActive,
	InputOutlineColorActive: InputOutlineColorActive
});

export { GridBreakpointXsMax as G, SpacerSmd as S, _variables_es6 as _, SpacerMd as a, SpacerMlg as b, SpacerLg as c, SpacerXl as d, GridBreakpointSmMin as e, GridBreakpointSmMax as f, GridBreakpointMdMin as g, GridBreakpointMdMax as h, GridBreakpointLgMin as i };
